import React, { useState, useEffect } from 'react'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'
import styles from './_.module.css'
import { Input, CheckboxGroup } from '../../../atoms'

interface DropdownCheckboxListProps {
  name: string
  list: { id: string | number; title: string }[]
  filters: FilterValueType
  onFilterChange: (filterName: string, filterValues: any) => void
  closeDropdown: () => void
}

/* dropdown overlay components */
const DropdownCheckboxList: React.FC<DropdownCheckboxListProps> = ({
  name,
  list,
  filters,
  onFilterChange,
  closeDropdown
}) => {
  const [values, setValues] = useState<CheckboxValueType[]>([])

  const [searchText, setSearchText] = useState('')
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchText(event.target.value)
  }

  /*  if filter is removed or added from parent components then if should be reflected on checkbox as well for now checking the number of items in the array works */
  useEffect(() => {
    const filterValue = filters[name]
    if (Array.isArray(filterValue)) setValues(filterValue)
    else {
      setValues([])
    }
  }, [filters])

  // changing list properties to contain label & value required by `options` prop
  const options = list.map(item => ({
    label: item.title,
    value: item.id
  }))

  const applyFilter = (): void => {
    onFilterChange(name, values)
    closeDropdown()
  }

  const resetFilter = (): void => {
    onFilterChange(name, [])
    setValues([])
    closeDropdown()
  }

  return (
    <div className={`scrollbar ${styles.overlayContainer}`}>
      {options.length > 15 && (
        <div className={styles.searchInput}>
          <Input
            allowClear={true}
            placeholder="Search"
            onChange={handleChange}
            value={searchText}
            autoFocus={true}
          />
        </div>
      )}
      <CheckboxGroup
        className={styles.checkboxGroup}
        options={options.filter(item =>
          item.label.toLowerCase().includes(searchText.toLowerCase())
        )}
        defaultValue={values || []}
        value={values}
        onChange={(values): void => setValues(values)}
      />
      <div className={styles.overlayContainerButtons}>
        <button
          className={`${styles.button} ${styles.primary}`}
          onClick={applyFilter}
        >
          Apply
        </button>
        <button className={styles.button} onClick={resetFilter}>
          Reset
        </button>
      </div>
    </div>
  )
}

export default DropdownCheckboxList
